import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface SelectionGridSkeletonProps {
  items: number;
  showIcon?: boolean;
  showSecondaryLine?: boolean;
  className?: string;
}

export function SelectionGridSkeleton({
  items,
  showIcon = true,
  showSecondaryLine = true,
  className,
}: SelectionGridSkeletonProps) {
  return (
    <div className={cn("grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3", className)}>
      {Array.from({ length: items }).map((_, index) => (
        <Card key={index} className="border-border/80 shadow-sm">
          <CardContent className="space-y-3 p-5">
            {showIcon && <Skeleton className="h-24 w-full rounded-xl" />}
            <Skeleton className="h-4 w-28" />
            {showSecondaryLine && <Skeleton className="h-3 w-20" />}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
